<header>
    <img id="header-image" src="../../../assets/images/logo_fiduciaria_fondo_blanco.svg"
        alt="image not found" class="imgCenter" routerLink="/login">
</header>